module.exports = "../dist/frontend/icons/ui/search.svg?b2988b67a449c774b7f30f0f7aa53475";